export type HeaderPriceView = { kind: 'text'; text: string } | { kind: 'empty' } | { kind: 'skeleton' };

export interface HeaderPriceInput {
  hasArgs: boolean;
  zeroText: string;
  quotedText: string | undefined;
  lastQuotedText: string | undefined;
  isError: boolean;
}

export function getHeaderPriceView({
  hasArgs,
  zeroText,
  quotedText,
  lastQuotedText,
  isError,
}: HeaderPriceInput): HeaderPriceView {
  if (!hasArgs) {
    return { kind: 'text', text: zeroText };
  }

  if (quotedText !== undefined) {
    return { kind: 'text', text: quotedText };
  }

  if (isError) {
    return { kind: 'empty' };
  }

  if (lastQuotedText !== undefined) {
    return { kind: 'text', text: lastQuotedText };
  }

  return { kind: 'skeleton' };
}

export function getNextLastQuotedText(hasArgs: boolean, quotedText: string | undefined, previous: string | undefined) {
  if (!hasArgs) {
    return undefined;
  }

  return quotedText ?? previous;
}
